import { BreadcrumbDesignTokens } from '@primeuix/themes/types/breadcrumb';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { tDeep } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/breadcrumb/index.ts
const br = tDeep(componentCommon.breadcrumb);

export const BreadcrumbTelekomDT: BreadcrumbDesignTokens = {
  root: {
    background: br.background,
    padding: br.padding,
    gap: br.gap,
  },
  item: {
    color: br.item.color,
  },
};
